// Tiny pub-sub used to keep the persisted auth store in sync with token
// rotations performed by the apiClient's 401-retry interceptor. Without
// this, `localStorage['accessToken'|'refreshToken']` (which the request
// interceptor writes) drifts from `localStorage['maie-emr-auth']` (which
// the zustand auth store persists), and on the next SPA reload zustand
// rehydrates a refresh token the backend has already revoked → kicked
// to /login.
//
// Lives in `services/` so both `apiClient.ts` and `stores/useAuthStore.ts`
// can import it without creating a cycle (apiClient already imports from
// `services/`, and the store imports apiClient).

type Tokens = { accessToken: string; refreshToken: string };
type Listener = (tokens: Tokens) => void;

const listeners = new Set<Listener>();

export const onTokensRefreshed = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const emitTokensRefreshed = (tokens: Tokens): void => {
  for (const listener of listeners) {
    try {
      listener(tokens);
    } catch (err) {
      console.error('[authBus] listener threw', err);
    }
  }
};
